export default "__VITE_ASSET__c26e69a2__"